import { Link } from "react-router-dom";
import { useState } from "react";

export default function FinalCTASection() {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new URLSearchParams(new FormData(form) as unknown as URLSearchParams);
    fetch("https://readdy.ai/api/form/d6va45dt4s7j0tv5icu0", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: data.toString(),
    }).then(() => {
      setSubmitted(true);
      form.reset();
    });
  };

  return (
    <section className="bg-white py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Left */}
          <div>
            <p className="text-[#E8500A] font-bold text-xs tracking-widest uppercase mb-3">Get Help Today</p>
            <h2 className="text-4xl lg:text-5xl font-black text-gray-900 mb-5 leading-tight" style={{ fontFamily: "'Barlow', sans-serif" }}>
              Need Plumbing or
              <br />
              <span className="text-[#E8500A]">Heating Help?</span>
            </h2>
            <p className="text-gray-500 text-lg mb-8 leading-relaxed">
              Call now for fast, reliable service. Our licensed Master Plumber team is ready to handle your plumbing or heating needs today.
            </p>

            {/* Primary call card */}
            <div className="bg-[#0B1829] rounded-2xl p-7 mb-5">
              <p className="text-gray-400 text-xs font-semibold tracking-widest uppercase mb-3">
                <i className="ri-alarm-warning-line text-[#E8500A] mr-1.5" />
                24/7 Emergency Line
              </p>
              <a href="tel:8178324968" className="flex items-center gap-4 text-white hover:text-orange-300 transition-colors group">
                <span className="w-14 h-14 flex items-center justify-center bg-[#E8500A] rounded-xl flex-shrink-0 group-hover:bg-[#d14508] transition-colors">
                  <i className="ri-phone-fill text-2xl" />
                </span>
                <div>
                  <p className="text-3xl font-black" style={{ fontFamily: "'Barlow', sans-serif" }}>(817) 832-4968</p>
                  <p className="text-gray-500 text-xs mt-0.5">Arlington &amp; surrounding DFW areas</p>
                </div>
              </a>
            </div>

            <div className="bg-[#F8F7F4] rounded-2xl p-6 border border-gray-100 mb-6">
              <p className="text-gray-400 text-xs font-semibold tracking-widest uppercase mb-3">Dallas Direct Line</p>
              <a href="tel:9722625113" className="flex items-center gap-3 text-gray-900 hover:text-[#E8500A] transition-colors">
                <span className="w-10 h-10 flex items-center justify-center bg-orange-50 rounded-lg flex-shrink-0">
                  <i className="ri-phone-line text-[#E8500A]" />
                </span>
                <span className="font-black text-xl" style={{ fontFamily: "'Barlow', sans-serif" }}>(972) 262-5113</span>
              </a>
            </div>

            {/* Trust signals row */}
            <div className="flex flex-wrap gap-4">
              {[
                { icon: "ri-shield-check-fill", label: "Licensed #M12160" },
                { icon: "ri-timer-flash-fill", label: "Same-Day Available" },
                { icon: "ri-hand-heart-line", label: "Satisfaction Guaranteed" },
              ].map((t) => (
                <div key={t.label} className="flex items-center gap-2 text-gray-500 text-sm">
                  <i className={`${t.icon} text-[#E8500A]`} />
                  {t.label}
                </div>
              ))}
            </div>
          </div>

          {/* Right — Form */}
          <div className="bg-[#F8F7F4] rounded-2xl overflow-hidden border border-gray-100">
            <div className="bg-[#E8500A] px-7 py-5">
              <h3 className="font-black text-xl text-white" style={{ fontFamily: "'Barlow', sans-serif" }}>
                Request Service Online
              </h3>
              <p className="text-orange-100/80 text-xs mt-1">We respond within the hour during business hours</p>
            </div>
            <div className="p-7">
              {submitted ? (
                <div className="text-center py-8">
                  <div className="w-14 h-14 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-4">
                    <i className="ri-check-line text-2xl text-green-600" />
                  </div>
                  <h4 className="font-black text-xl text-gray-900 mb-2" style={{ fontFamily: "'Barlow', sans-serif" }}>Request Sent!</h4>
                  <p className="text-gray-500 text-sm mb-4">
                    We&apos;ll reach out shortly. For urgent issues, call{" "}
                    <a href="tel:8178324968" className="text-[#E8500A] font-semibold">(817) 832-4968</a>.
                  </p>
                  <button onClick={() => setSubmitted(false)} className="text-[#E8500A] text-sm font-semibold hover:underline cursor-pointer">
                    Submit another request
                  </button>
                </div>
              ) : (
                <form id="final-cta-form" data-readdy-form onSubmit={handleSubmit} className="space-y-4">
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-xs font-semibold text-gray-700 mb-1.5" htmlFor="cta-first">First Name <span className="text-[#E8500A]">*</span></label>
                      <input id="cta-first" name="first_name" type="text" required placeholder="John" className="w-full border border-gray-200 bg-white rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#E8500A] focus:ring-1 focus:ring-[#E8500A]" />
                    </div>
                    <div>
                      <label className="block text-xs font-semibold text-gray-700 mb-1.5" htmlFor="cta-last">Last Name</label>
                      <input id="cta-last" name="last_name" type="text" placeholder="Smith" className="w-full border border-gray-200 bg-white rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#E8500A] focus:ring-1 focus:ring-[#E8500A]" />
                    </div>
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-700 mb-1.5" htmlFor="cta-phone">Phone <span className="text-[#E8500A]">*</span></label>
                    <input id="cta-phone" name="phone" type="tel" required placeholder="(817) 555-0123" className="w-full border border-gray-200 bg-white rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#E8500A] focus:ring-1 focus:ring-[#E8500A]" />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-700 mb-1.5" htmlFor="cta-email">Email <span className="text-[#E8500A]">*</span></label>
                    <input id="cta-email" name="email" type="email" required placeholder="john@email.com" className="w-full border border-gray-200 bg-white rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#E8500A] focus:ring-1 focus:ring-[#E8500A]" />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-700 mb-1.5" htmlFor="cta-service">Service Needed</label>
                    <select id="cta-service" name="service" className="w-full border border-gray-200 bg-white rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#E8500A] focus:ring-1 focus:ring-[#E8500A]">
                      <option value="">Select a service...</option>
                      <option>Plumbing Repair</option>
                      <option>Drain Cleaning</option>
                      <option>Water Heater</option>
                      <option>Slab Leak Detection</option>
                      <option>Grease Trap</option>
                      <option>Welding</option>
                      <option>Emergency Service</option>
                      <option>Other</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-700 mb-1.5" htmlFor="cta-message">Message</label>
                    <textarea id="cta-message" name="message" rows={3} maxLength={500} placeholder="Describe your issue..." className="w-full border border-gray-200 bg-white rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#E8500A] focus:ring-1 focus:ring-[#E8500A] resize-none" />
                  </div>
                  <button type="submit" className="w-full bg-[#E8500A] hover:bg-[#d14508] text-white font-bold py-3.5 rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer">
                    Submit Service Request
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
